import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { ConnectionService } from '../shared-services/connection.service';
import { environment } from 'src/environments/environment';
import { ClickResponse } from '../auth/click.response.model';
import { ApplicationListItem } from '../home/application.list.item.model';
import { transition, style, animate, trigger } from '@angular/animations';
import { GuidedTour, GuidedTourService, Orientation } from 'ngx-guided-tour';

@Component({
    selector: 'app-applications-list',
    templateUrl: './applications-list.component.html',
    styleUrls: ['./applications-list.component.css'],
    animations: [
        trigger(
            'inOutAnimation',
            [
                transition(
                    ':enter',
                    [
                        style({ opacity: 0, display: 'none' }),
                        animate('0.1s 0.5s ease-out',
                            style({ opacity: 1, display: 'block' }))
                    ]
                )
            ]
        )
    ]
})
export class ApplicationsListComponent implements OnInit {

    public pageSize: number;
    public pageNumber: number;
    public tabNumber: number;

    public tour: GuidedTour = {
        tourId: 'purchases-tour',
        useOrb: true,
        steps: [
            {
                title: 'Welcome to the Guided Tour Demo',
                selector: '#header-home-link',
                content: 'Step 1',
                orientation: Orientation.Bottom
            },
            {
                title: 'General page step',
                content: 'We have the concept of general page steps so that a you can introuce a user to a page or non specific instructions',
            },
            {
                title: 'Positioning',
                selector: '#header-apply-link',
                content: 'Step position can be set so that steps are always in view. This step is on the left.',
                orientation: Orientation.Left
            },
            {
                title: 'Positioning 2',
                selector: '#header-help-link',
                content: 'This step is on the top.',
                orientation: Orientation.Top
            },
            {
                title: 'Positioning 3',
                selector: '#header-home-link',
                content: 'Step position can be set so that steps are always in view. This step is on the right.',
                orientation: Orientation.Right
            }
        ]
    };

    public options = {
        open: true,
        currentTab: 'application-tab',
        contractsAmount: 0
    };

    constructor(
        public router: Router,
        private route: ActivatedRoute,
        private authService: AuthService,
        private guidedTourService: GuidedTourService,
        private connectionService: ConnectionService) {
        const navigation = this.router.getCurrentNavigation();
        setTimeout(() => {
            //this.guidedTourService.startTour(this.tour);
        }, 1000);
    }

    ngOnInit() {
        this.tabNumber = Number(this.route.snapshot.queryParams.tab) ? Number(this.route.snapshot.queryParams.tab) : 0;
        this.pageNumber = Number(this.route.snapshot.queryParams.page) ? Number(this.route.snapshot.queryParams.page) : 0;
        this.pageSize = Number(this.route.snapshot.queryParams.size) ? Number(this.route.snapshot.queryParams.size) : 10;
        // http://localhost:4200/applications?tab=1&page=1&size=10
        //this.loadContractsAmount();
    }

    loadContractsAmount() {
        const postData = {
            'email': '',
            'legalName': '',
            'finishDate': '',
            'startDate': '',
            'salesPersonId': 0,
            'vendorId': this.authService.getVendorId(),
            'status': ['ONLYCONTRACTSIN']
        };
        this.connectionService.postRequest(
            environment.gateway + 'findApplications/0/1', postData,
            'application/json', 'sp_id=' + this.authService.getSalesPersonId())
            .subscribe(
                (data: ClickResponse) => {
                    this.options.contractsAmount = data.object && data.object.totalElements ? data.object.totalElements : 0;
                },
                (error: any) => {
                    console.log(error);
                });
    }

}
